import { useState, useEffect } from 'react';
import EditForm from '../../../utils/utilities/EditForm';

import { fields, initialValues, schema } from "./config";

const EditStation = ({dialog = false}) => {

  return (
    <EditForm title={"Service Station"} initialValues={initialValues} fields={fields} schema={schema} url={"services/stations"} dialog={dialog}>
      
     </EditForm>
  );
}

export default EditStation;